module.exports = __webpack_public_path__ + "img/SAFo_StrongPasswords_Length.3c8f52e7.svg";